import { makeStyles } from '@mui/styles'
import * as React from 'react'

import type { Theme } from '../../design-tokens/theme'
import { Localized } from '../../localization/react'
import Flex from '../../primitives/Flex'
import Heading from '../../primitives/Heading'
import Icon, { Icons } from '../../primitives/Icon'
import Text from '../../primitives/Text'

import SubscribeToNewsletterButton from './SubscribeToNewsletterButton'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      alignItems: 'center',
    },
  },
  venueLogo: {
    maxHeight: theme.space['128px'],
    maxWidth: theme.space['128px'],
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}))

interface Props {
  onButtonClick: () => void
  venueName: string
  venueImage?: string | null
}

const SubscribeToNewsletterBanner: React.FC<React.PropsWithChildren<Props>> = ({
  onButtonClick,
  venueName,
  venueImage,
}) => {
  const classes = useStyles()

  return (
    <Flex
      alignItems="flex-start"
      justifyContent="space-between"
      horizontalSpacing="wide"
      className={classes.container}
      fullWidth
    >
      <Flex flexDirection="column" verticalSpacing="default" alignItems={['center', 'center', 'flex-start']}>
        <Heading is="h2" variant="normal">
          <Localized id="newsletter-banner-title" params={{ venueName }} />
        </Heading>
        <Text>
          <Localized id="newsletter-banner-subtitle" params={{ venueName }} />
        </Text>
        <SubscribeToNewsletterButton onClick={onButtonClick} />
      </Flex>
      {venueImage ? (
        <img src={venueImage} alt={`${venueName} Logo`} className={classes.venueLogo} />
      ) : (
        <Icon icon={Icons.EMAIL} size="xxx-large" />
      )}
    </Flex>
  )
}

export default SubscribeToNewsletterBanner
